/**
 * Reusable checkbox component.
 */

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import * as tokens from "@khanacademy/wonder-blocks-tokens";
import {colorUtil} from "@khan/shared-styles";

// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import DeprecatedIcon from "#shared-styles-package/deprecated-icon.tsx";

type Props = {
    ariaLabel?: string;
    checked?: boolean;
    disabled?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FocusEvent) => void;
    onBlur?: (e: React.FocusEvent) => void;
    name?: string;
};

type State = {
    focused: boolean;
};

/**
 * @deprecated Use Checkbox from @khanacademy/wonder-blocks-form instead.
 */
class DeprecatedCheckbox extends React.Component<Props, State> {
    state: State = {focused: false};

    handleFocus(e: React.FocusEvent): void {
        this.setState({focused: true});
        if (this.props.onFocus) {
            return this.props.onFocus(e);
        }
    }

    handleBlur(e: React.FocusEvent): void {
        this.setState({focused: false});
        if (this.props.onBlur) {
            return this.props.onBlur(e);
        }
    }

    render(): React.ReactNode {
        return (
            <div
                className={css(
                    styles.checkbox,
                    this.props.checked &&
                        !this.props.disabled &&
                        styles.checked,
                    this.props.disabled && styles.disabled,
                    this.state.focused && styles.focused,
                )}
            >
                {this.props.checked && (
                    <DeprecatedIcon
                        icon={okIcon}
                        size={9}
                        className={css(styles.checkboxIcon)}
                    />
                )}
                <input
                    type="checkbox"
                    aria-label={this.props.ariaLabel}
                    className={css(
                        styles.input,
                        this.props.disabled && styles.inputDisabled,
                    )}
                    name={this.props.name}
                    checked={this.props.checked}
                    disabled={this.props.disabled}
                    onChange={this.props.onChange}
                    onFocus={(e) => this.handleFocus(e)}
                    onBlur={(e) => this.handleBlur(e)}
                />
            </div>
        );
    }
}

const okIcon = {
    path: "M37.964 76.048q-2.576 0-4.368-1.792l-31.864-31.864q-1.792-1.792-1.792-4.368t1.792-4.368l8.736-8.68q1.792-1.792 4.368-1.792t4.312 1.792l18.816 18.872 42-42.056q1.792-1.792 4.368-1.792t4.312 1.792l8.736 8.736q1.792 1.792 1.792 4.368t-1.792 4.312l-55.048 55.048q-1.792 1.792-4.368 1.792z",
    width: 100,
    height: 76.637,
} as const;

const kaGreen = colorUtil.parse(tokens.color.green);

const styles = StyleSheet.create({
    checkbox: {
        backgroundImage: "linear-gradient(#fff, #ddd)",
        border: "1px solid #aaa",
        borderRadius: 3,
        boxSizing: "border-box",
        display: "inline-block",
        height: 16,
        margin: 3,
        marginTop: 1.5,
        overflow: "hidden",
        position: "relative",
        verticalAlign: "top",
        width: 16,
    },

    checked: {
        background: colorUtil.format(colorUtil.darken(kaGreen, 0.1)),
        color: "#fff",
    },

    disabled: {
        color: "#999",
        opacity: 0.4,
    },

    focused: {
        boxShadow: `0px 0px 3px ${colorUtil.format(colorUtil.fade(kaGreen, 0.8))}`,
    },

    checkboxIcon: {
        display: "block",
        margin: "2px 0 0 1px",
    },

    input: {
        cursor: "pointer",
        height: "100%",
        left: 0,
        margin: 0,
        opacity: 0,
        position: "absolute",
        top: 0,
        width: "100%",
    },

    inputDisabled: {
        cursor: "default",
    },
});

export default DeprecatedCheckbox;
